import React, { useState } from "react";

import {
  SectorMap,
  // SectorTreeMap,
  SectorBar,
  // SectorTable,
  SectorTableCard,
} from "../../components/analytics/index.jsx";
const SectorScope = () => {
  const [selectedSector, setSelectedSector] = useState("All Sectors");
  return (
    <div className="p-6 space-y-6 bg-darkMode-background">
      <h1 className="text-4xl md:text-5xl font-bold mb-2">
        Sector <span className="text-market-teal">Pulse</span>
      </h1>
      <SectorMap big={true} />
      <SectorBar onSectorClick={setSelectedSector} />
      <SectorTableCard selectedSector2={selectedSector} />
      <div className="grid grid-cols-2 gap-4"></div>
    </div>
  );
};

export default SectorScope;
